<!-- ============================================================== -->
<!-- Profile - style you can find in footer.scss -->
<!-- ============================================================== -->

<!-- TODO! traer la version del sistema de la base de datos -->
<p class="" style="text-decoration: none;">Sistema de Gestión para Ópticas <a routerLink="portal/timeline/sysopt"  matTooltip="Revisar últimos cambios del sistema"><span style="font-weight: 550; color: #1E88E5">Optagestion v{{version}}</span></a> - Desarrollado por <a style="font-weight: 550; color: #1E88E5; text-decoration: none; cursor: pointer;" href="http://optagestion.cl" target="_blank">Optagestion</a> © Todos los derechos reservados.
</p>

